<!--
 * @Date: 2022-08-30 15:37:14
 * @LastEditors: 雷安刚 15108293674@163.com
 * @LastEditTime: 2023-08-04 16:25:54
 * @FilePath: \front_admin\src\App.vue
-->
<!--suppress ALL -->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    if (process.env.NODE_ENV != "build") {
      window.baseGate.socketUrl = "ws://192.168.2.252:9998";
    } else {
      window.baseGate.socketUrl = "ws://api.joolgo.com:800";
    }
    this.redirectPopup();
  },
  methods: {
    redirectPopup() {
      // 需要挂载到内部的弹窗的className，用作标记
      const whiteList = [
        "el-select-dropdown el-popper",
        "el-picker-panel el-date-range-picker el-popper",
        "el-picker-panel el-date-range-picker el-popper has-time",
        "el-picker-panel el-date-picker el-popper",
        "el-popper el-cascader__dropdown",
        "el-select-dropdown el-popper is-multiple",
        "el-tooltip__popper is-dark",
        "el-dialog__wrapper commonDialog clickLight",
        "el-dialog__wrapper",
        "el-popover el-popper",
        "el-scrollbar",
        "el-picker-panel__body-wrapper",
        "el-cascader-panel",
      ];
      let originFn = document.body.appendChild.bind(document.body);
      // 重写appendChild方法
      document.body.appendChild = (dom) => {
        const moreSearch_ = document.getElementById("moreSearch");
        if (moreSearch_ && moreSearch_.style.display !== "none") {
          // 根据标记，来区分是否用新的挂载方式
          if (whiteList.includes(dom.childNodes[0].className)) {
            moreSearch_.appendChild(dom);
          } else {
            originFn(dom);
          }
        } else {
          originFn(dom);
          return;
        }
      };
    },
  },
};
</script>

<style lang="less">
@import "components/libs/css/public.css";
.el-picker-panel {
  z-index: 99999 !important;
}
// 加载中使用
.mainContainer {
  position: relative;
}
</style>
